import Debug from 'debug'
import RESTResource from '../rest/RESTResource.js'
import protectedSymbol from '../util/protected.js'

const debug = Debug('cbio.Policy')

export default class Policy extends RESTResource {
  constructor (api, resource = {}) {
    super(api, resource)
    debug('constructed Policy')
  }

  static url (state = {}) {
    return `/api/1/policy/${state.id || ''}`
  }

  #resourcePolicy = (resource) => {
    const policy = this[protectedSymbol].getResource()
    const result = policy[resource] || policy['*'] || {}
    return { ...result }
  }

  hasPermission (permission) {
    if (!permission) throw new Error('permission is required')
    if (typeof permission !== 'string') throw new Error('permission should be a string')

    const [resource, action] = permission.split(':')
    const permissions = this.#resourcePolicy(resource)?.permissions

    if (typeof permissions === 'undefined') return true
    return permissions.includes(action)
  }

  toJSON = () => {
    const policy = this[protectedSymbol].getResource()
    return {
      ...policy
    }
  }
}
